import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SignIn from './pages/SignIn';
import ClientDashboard from './pages/ClientDashboard';
import AdminDashboard from './pages/AdminDashboard';
import StaffDashboard from './pages/StaffDashboard';
import OnboardingForm from './components/OnboardingForm';
import SignUp from './pages/SignUp';
import ProfileSettings from './pages/ProfileSettings';
import SecurityTest from './pages/SecurityTest';
import UserManagement from './pages/UserManagement';
import ClientManagement from './pages/ClientManagement';
import TaskManagement from './pages/TaskManagement';
import ClientTasks from './pages/ClientTasks';
import Documents from './pages/Documents';
import EntityFormationIntakePage from './pages/EntityFormationIntakePage';
import EntityFormationIntakeCompletePage from './pages/EntityFormationIntakeCompletePage';
import EntityFormationPage from './pages/EntityFormationPage';
import EntityFormationViewPage from './pages/EntityFormationViewPage';
import AdminEntityFormationPage from './pages/AdminEntityFormationPage';
import AdminEntityFormationViewPage from './pages/AdminEntityFormationViewPage';
import AdminDocuments from './pages/AdminDocuments';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PrivacyRequests from './pages/PrivacyRequests';
import AdminPrivacyRequests from './pages/AdminPrivacyRequests';
import GLBAPrivacyNotice from './pages/GLBAPrivacyNotice';
import GLBAPreferences from './pages/GLBAPreferences';
import AdminGLBA from './pages/AdminGLBA';
import AdminAuditLogs from './pages/AdminAuditLogs';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<SignIn />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/glba-privacy-notice" element={<GLBAPrivacyNotice />} />
          
          {/* Protected Routes - All authenticated users */}
          <Route 
            path="/onboarding" 
            element={
              <ProtectedRoute>
                <OnboardingForm />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/client-dashboard" 
            element={
              <ProtectedRoute>
                <ClientDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile-settings" 
            element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/billing" 
            element={
              <ProtectedRoute>
                <div style={{ padding: '2rem' }}>Billing Page - Coming Soon</div>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/intake/entity-formation" 
            element={
              <ProtectedRoute>
                <EntityFormationIntakePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/intake/entity-formation/complete" 
            element={
              <ProtectedRoute>
                <EntityFormationIntakeCompletePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/entity-formation" 
            element={
              <ProtectedRoute requiredRole="client">
                <EntityFormationPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/entity-formation/view/:submissionId" 
            element={
              <ProtectedRoute requiredRole="client">
                <EntityFormationViewPage />
              </ProtectedRoute>
            } 
          />

          {/* Admin-only Routes */}
          <Route 
            path="/admin-dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/user-management" 
            element={
              <ProtectedRoute requiredRole="admin">
                <UserManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/security-test" 
            element={
              <ProtectedRoute requiredRole="admin">
                <SecurityTest />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/entity-formation" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminEntityFormationPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/entity-formation/view/:submissionId" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminEntityFormationViewPage />
              </ProtectedRoute>
            } 
          />
        <Route
          path="/admin/documents"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminDocuments />
            </ProtectedRoute>
          }
        />
          <Route 
            path="/admin/privacy-requests"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminPrivacyRequests />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/admin/glba" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminGLBA />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/audit-logs" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminAuditLogs />
              </ProtectedRoute>
            } 
          />

          {/* Staff and Admin Routes */}
          <Route 
            path="/staff-dashboard" 
            element={
              <ProtectedRoute requiredRole="staff">
                <StaffDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/clients" 
            element={
              <ProtectedRoute requiredRole="staff">
                <ClientManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/tasks" 
            element={
              <ProtectedRoute requiredRole="staff">
                <TaskManagement />
              </ProtectedRoute>
            } 
          />

          {/* Client Routes */}
          <Route 
            path="/client-tasks" 
            element={
              <ProtectedRoute requiredRole="client">
                <ClientTasks />
              </ProtectedRoute>
            } 
          />
        <Route
          path="/documents"
          element={
            <ProtectedRoute requiredRole="client">
              <Documents />
            </ProtectedRoute>
          }
        />
          <Route 
            path="/privacy-requests" 
            element={
              <ProtectedRoute requiredRole="client">
                <PrivacyRequests />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/glba-preferences" 
            element={
              <ProtectedRoute>
                <GLBAPreferences />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
